<template>
  <div>{{ getValue() }}</div>
</template>
<script>
export default {
  props: {
    cellData: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    getValue() {
      let retVal = 'No text available';
      
      if (this.cellData && this.cellData.text) {
        // console.log(this.cellData.text);
        if (this.cellData.text.indexOf('^') >= 0) {
          retVal = this.cellData.text.substring(this.cellData.text.indexOf('^') + 1);
        } else {
          retVal = this.cellData.text;
        }
      }
      // console.log('-> ' + retVal);
      return retVal;
    }
  }

};
</script>
<style>

</style>
